import React from 'react';
import PropTypes from 'prop-types';
import H from '../Texts/H/H';
import Illustration from '../Image/Illustration/Illustration';
import * as S from './StateMessage.styles';
import P from '../Texts/P/P';
import Button from '../Button/Button';

const StateMessage = ({
  title,
  subtitle,
  illustration,
  button,
  children,
  variant = 'regular',
}) => {
  const currentVariant = {
    regular: {
      weight: 'regular',
      modifier: 'regular',
    },
    'strong-bold': {
      weight: 'bold',
      modifier: 'strong',
    },
  };

  const renderButton = (propsButton) => {
    const {
      iconAlign = 'none',
      variant = 'primary',
      text,
      ...defaultProps
    } = propsButton;
    const defaultPropsButton = {
      ...defaultProps,
      size: 'md',
      iconAlign,
      variant,
    };

    return (
      text && (
        <S.StateMessageContenButton>
          <Button {...defaultPropsButton}>{text}</Button>
        </S.StateMessageContenButton>
      )
    );
  };

  const { weight, modifier } = currentVariant[variant];

  return (
    <S.StateMessageWrapper>
      {illustration && <Illustration name={illustration} />}
      <S.StateMessageContent>
        <H
          type='5'
          align='center'
          variant='neutral'
          weight={weight}
          modifier={modifier}
        >
          {title}
        </H>
        {subtitle && (
          <P type='1' align='center' variant='neutral'>
            {subtitle}
          </P>
        )}
      </S.StateMessageContent>
      {button && renderButton(button)}
      {children}
    </S.StateMessageWrapper>
  );
};

StateMessage.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  illustration: PropTypes.string,
  button: PropTypes.shape({
    iconAlign: PropTypes.string,
    icon: PropTypes.string,
    text: PropTypes.string,
    variant: PropTypes.string,
    onClick: PropTypes.func,
  }),
  variant: PropTypes.oneOf(['regular', 'strong-bold']),
};
export default StateMessage;
